/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import {
  setAccessoryList,
  setColors,
  setTypes,
  setHeights,
  setInputDataToSend,
  setNecessaryProductsQuantity,
  setPanelsList,
  setPostsList,
  setAddedProducts,
  setCornerPostsList,
  setTreeStructureSettings,
  setCornerPostAccessoryList,
  setCornerAccessoryList,
} from './actions';

const formReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setPanelsList, (state, action) => {
      state.panelsList = action.payload.panelsList;
    })
    .addCase(setPostsList, (state, action) => {
      state.postsList = action.payload.postsList;
    })
    .addCase(setCornerPostsList, (state, action) => {
      state.cornerPostsList = action.payload.cornerPostsList;
    })
    .addCase(setAccessoryList, (state, action) => {
      state.accessoryList = action.payload.accessoryList;
    })
    .addCase(setCornerPostAccessoryList, (state, action) => {
      state.cornerPostAccessoryList = action.payload.accessoryList;
    })
    .addCase(setCornerAccessoryList, (state, action) => {
      state.cornerAccessoryList = action.payload.accessoryList;
    })
    .addCase(setTreeStructureSettings, (state, action) => {
      state.treeStructureSettings = {
        level: action.payload.level !== null
          ? action.payload.level : state.treeStructureSettings.level,
        parentId: action.payload.parentId !== null ? action.payload.parentId : null,
        parentName: action.payload.parentName !== null ? action.payload.parentName : null,
      };
    })
    .addCase(setAddedProducts, (state, action) => {
      state.addedProducts = action.payload.uniqueAccessory;
    })
    .addCase(setColors, (state, action) => {
      state.colors = action.payload.colors;
    })
    .addCase(setTypes, (state, action) => {
      state.types = action.payload.types;
    })
    .addCase(setHeights, (state, action) => {
      state.heights = action.payload.heights;
    })
    .addCase(setInputDataToSend, (state, action) => {
      if (action.payload.key === 'all') {
        state.inputDataToSend = action.payload.data;
      } else {
        state.inputDataToSend[action.payload.key] = action.payload.data;
      }
    })
    .addCase(setNecessaryProductsQuantity, (state, action) => {
      state.necessaryProductsQuantity = action.payload.productsWithQuantity;
    });
});

export default formReducer;
